import { createSlice } from "@reduxjs/toolkit";
import { format } from "date-fns";
import { FilterStateStores } from "./types";
import { getPreviousDay } from "../../../../../utils/previousDay";

const INITIAL_STATE: FilterStateStores = {
  filters: {
    date: format(getPreviousDay() || new Date(), "yyyy-MM-dd"),
    meta: {
      page: 1,
    },
  },
};

const filterSlice = createSlice({
  name: "filter",
  initialState: INITIAL_STATE,
  reducers: {
    setFilter(state, action) {
      state.filters[action.payload.key] = action.payload.value;
    },
  },
});

export const { setFilter } = filterSlice.actions;
export default filterSlice.reducer;
